import { render, staticRenderFns } from "./team-details.vue?vue&type=template&id=3c31dc09&scoped=true&"
import script from "./team-details.vue?vue&type=script&lang=js&"
export * from "./team-details.vue?vue&type=script&lang=js&"
import style0 from "./team-details.vue?vue&type=style&index=0&id=3c31dc09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31dc09",
  null
  
)

component.options.__file = "team-details.vue"
export default component.exports